import React from "react";
import { ListPageHeader } from "../../common/DataList";
import AllRecipientsFilters from "./AllRecipientsFilters";
import AllRecipientsList from "./AllRecipientsList";

const AllRecipients = () => {
  return (
    <div className="container-fluid px-5 my-5 list-page">
      <ListPageHeader
        title="Tous les allocataires"
        subtitle="Cette recherche s'effectue sur l'ensemble des collections d'allocataires."
      />
      <AllRecipientsFilters />
      <AllRecipientsList />
    </div>
  );
};

export default AllRecipients;
